import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X"; // Optional - if using Twitter

export default function LoginFooter() {
  return (
    <Box sx={{ backgroundColor: "#1E1E1E", color: "#fff", pt: 4 }}>
      {/* Top Warning */}
      <Box
        sx={{
          backgroundColor: "#2B2B2B",
          borderRadius: "12px",
          mx: "auto",
          mb: 4,
          p: 2,
          maxWidth: "78%",
        }}
      >
        <Typography variant="body2" sx={{ color: "rgba(239, 239, 239, 1)" }}>
          <Box
            component="span"
            sx={{ color: "rgba(251, 105, 68, 1)", fontWeight: "600" }}
          >
            Risk Warning:
          </Box>{" "}
          Your capital is at risk. Leveraged products may not be suitable for
          everyone. Please consider our{" "}
          <Link href="#" underline="hover" color="inherit">
            Risk Disclosure
          </Link>
          .
        </Typography>
      </Box>

      <Container maxWidth="xl">
        {/* Top Row */}
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={8}>
            <Box
              sx={{
                display: "flex",
                gap: 3,
                flexWrap: "wrap",
              }}
            >
              {[
                "Privacy Policy",
                "Cookie Policy",
                "Vulnerability Policy",
                "Terms and Conditions",
              ].map((item, i) => (
                <Link
                  key={i}
                  href="#"
                  //   underline="hover"
                  color="rgba(239, 239, 239, 1)"
                  sx={{ fontWeight: 500 }}
                >
                  {item}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Social */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{ display: "flex", justifyContent: { sm: "flex-end" } }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" style={{ color: "#fff" }}>
                Follow Us:
              </Typography>
              <LinkedInIcon />
              <InstagramIcon />
              <FacebookIcon />
              <XIcon /> {/* optional */}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ backgroundColor: "#333", my: 3 }} />

        {/* Legal Section */}
        <Box sx={{ mb: 4 }}>
          <Typography
            variant="body2"
            sx={{ mb: 2, color: "rgba(141, 150, 154, 1)", fontWeight: 400 }}
          >
            <Box component="span" sx={{ color: "#fff", fontWeight: 500 }}>
              Legal:
            </Box>{" "}
            This website is operated by XM Global Limited with registered
            address at Suite 101, 63 Eve Street, Belize City, Belize.
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 2, color: "rgba(141, 150, 154, 1)", fontWeight: 400 }}
          >
            XM Global Limited, registered by the Financial Services Commission
            (FSC) under the Securities Industry Act 2021 (license number
            000261/27) and Trading Point of Financial Instruments Limited,
            authorised and regulated by Cyprus Securities and Exchange
            Commission (CySEC) (licence number 120/10), are members of Trading
            Point Group.
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 2, color: "rgba(141, 150, 154, 1)", fontWeight: 400 }}
          >
            <Box component="span" sx={{ color: "#fff", fontWeight: 500 }}>
              Risk Warning:
            </Box>{" "}
            Our services involve a significant risk and can result in the loss
            of your invested capital. Please read and ensure you fully
            understand our{" "}
            <Link href="#" underline="hover" color="inherit">
              Risk Disclosure
            </Link>
            .
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 2, color: "rgba(141, 150, 154, 1)", fontWeight: 400 }}
          >
            <Box component="span" sx={{ color: "#fff", fontWeight: 500 }}>
              Restricted Regions:
            </Box>{" "}
            XM Global Limited does not provide services for the residents of
            certain countries, such as the United States of America, Canada,
            Israel and the Islamic Republic of Iran.
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "rgba(141, 150, 154, 1)", fontWeight: 400 }}
          >
            XM does not direct its website and services to any individual in any
            country in which the use of its website and services are prohibited
            by local laws or regulations. When accessing this website from a
            country in which its use may or may not be prohibited, it is the
            user’s responsibility to ensure that any use of the website or
            services adhere to local laws or regulations. XM does not affirm
            that the information on its website is suitable to all
            jurisdictions.
          </Typography>
        </Box>

        <Divider sx={{ backgroundColor: "rgba(57, 61, 64, 1)", my: 3, height: "2px", }} />

        {/* Bottom Cookie Notice */}
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ pb: 4 }}
        >
          <Grid item xs={12} md={8}>
            <Typography variant="body2" color="gray">
              We are using cookies to give you the best experience on our
              website. Read more or change your{" "}
              <Link href="#" underline="hover" color="inherit">
                cookie settings
              </Link>
              .
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} textAlign={{ xs: "left", md: "right" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(36, 148, 201, 1)",
                textTransform: "none",
                px: 3,
                py: 1,
                fontWeight: 400,
                borderRadius: 2,
                fontSize:"14px"
              }}
            >
              Accept All Cookies
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
